import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const InboxSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default InboxSVG;
